import { getLocale } from '@/helpers/dates';
import ModalSettleRefund from '@/screens/reservations/modalSettleRefund';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Show from '../show/show';

const RefundHeader = ({ reservation }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'screens.details.reservation.header' });
  const language = useSelector((state) => state.app.language);
  const locale = getLocale(language);
  const navigate = useNavigate();

  return (
    <div className='container-header with-border'>
      <div className='row align-items-end'>
        <div className='col-auto'>
          <div className='light-grey container-small-title'>{t('titleRefund')}</div>
          <div className='container-title'>
            {reservation?.referenceCode}:{' '}
            {reservation?.activityName}
          </div>
        </div>
        <div className='col my-auto'></div>
        <div className='col-auto'>
          <div className='row'>
            <Show.When isTrue={reservation?.canSettleRefund}>
            <div className='col-auto'>
              <ModalSettleRefund
                locale={locale}
                onClose={() => {
                  navigate('/reservations-pending');
                }}
                reservation={reservation}
              />
            </div>
            </Show.When>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundHeader;
